import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { CourseFeedbackPoll } from '../../../../api/types/programs/course/feedback/course-feedback-poll';
import { deleteCourseFeedbackOperation } from '../operations/delete-course-feedback-operation';

export interface DeleteFeedbackDialogProps {
  programId: number;
  courseId: number;
  feedback: CourseFeedbackPoll;
  closeDialog: () => void;
}

export const DeleteFeedbackDialog: React.FC<DeleteFeedbackDialogProps> = ({
  programId,
  courseId,
  feedback,
  closeDialog,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    await deleteCourseFeedbackOperation(
      programId,
      courseId,
      feedback.id,
      setLoading,
      closeDialog,
    );
  };

  return (
    <div style={{ direction: 'rtl', padding: '8px', textAlign: 'center' }}>
      {/* Warning Icon */}
      <div style={{ marginBottom: '16px' }}>
        <i
          className="pi pi-exclamation-triangle"
          style={{
            fontSize: '3rem',
            color: '#f59e0b',
          }}
        />
      </div>

      {/* Message */}
      <div style={{ marginBottom: '8px' }}>
        <p
          style={{
            fontSize: '16px',
            fontWeight: 500,
            color: '#374151',
            margin: '0 0 8px 0',
          }}
        >
          האם אתה בטוח שברצונך למחוק את המשוב?
        </p>
        <p
          style={{
            fontSize: '18px',
            fontWeight: 600,
            color: '#1f2937',
            margin: '0 0 12px 0',
          }}
        >
          "{feedback.pollName}"
        </p>
        <p
          style={{
            fontSize: '14px',
            color: '#6b7280',
            margin: 0,
          }}
        >
          פעולה זו תמחק את המשוב לצמיתות. לא ניתן לשחזר את המשוב לאחר המחיקה.
        </p>
      </div>

      {/* Action Buttons */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '12px',
          marginTop: '24px',
        }}
      >
        <Button
          label="מחק משוב"
          icon="pi pi-trash"
          className="p-button-danger"
          onClick={handleDelete}
          loading={loading}
        />
        <Button
          label="ביטול"
          icon="pi pi-times"
          className="p-button-secondary p-button-outlined"
          onClick={closeDialog}
          disabled={loading}
        />
      </div>
    </div>
  );
};
